export const STATUS_MODULE = { 
    IDLE: 'initial',
    LOADED: 'loaded',
    ERROR: 'error',
}
  
export const STATUS_VIEWER = {
    IDLE: 'initial',
    LOADED: 'document loaded',
    RENDERED: 'document rendered',
    ERROR: 'error',
}